var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCegid = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#0046FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3946 96.9991C45.8657 96.9991 31 81.8416 31 60.938C31 39.6561 46.6208 24.002 68.1408 24.002C75.2993 23.9336 82.3676 25.605 88.7404 28.8732L82.9121 43.3213C78.8559 41.3058 74.3908 40.2539 69.8633 40.2472C58.4662 40.2472 49.476 46.8919 49.476 60.5596C49.476 74.2274 58.2067 80.8484 70.1465 80.8484C74.6457 80.8745 79.0586 79.611 82.8649 77.2068L89 89.9997C82.3643 94.6107 74.4693 97.0552 66.3946 96.9991Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCegid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cegid.589836602e738d597ec53bdd1c07fa00.svg";